import TabLayout from './crowdfunding_tab_layout'
import { connect } from 'react-redux'
import { publicContributionsListSelector } from 'redux/selectors/contributions'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)
  return {
    contributions: publicContributionsListSelector(state, ownProps),
    contributionsCount: state.txns && state.txns.contributionsCount,
    pledge: campaign.pledge,
    ...ownProps,
  }
}

export default connect(mapStateToProps)(TabLayout)
